import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import Drivesharing from './Drivesharing';
import SFVehicleTypes from '../UberToronto/SFVehicleTypes';
import WhyDrive from './WhyDrive';
import HowWorks from './HowWorks';
import LandingFaq from './LandingFaq';
import LandingSignup from './LandingSignup';
import TorontoFooter from '../../Layout/TorontoFooter';

import ScrollLock from 'react-scrolllock';

import './landingPage.css';
import { Helmet } from 'react-helmet';
import SFFooter from '../../Layout/SFFooter';

class LandingPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      currentPage: 0,
      lastPage: 0,
      loaded: [true, false, false, false, false, false, false, false]
    };
  }

  componentDidMount() {
    // this.checkVerified();
  }

  // checkVerified = async () => {
  //   const { client, history } = this.props;
  //   const { data } = await client.query({
  //     query: CHECK_VERIFICATION
  //   });

  //   if (data.currentUser) {
  //     if (
  //       this.props.loggedIn &&
  //       (this.props.status !== 'subscribed' ||
  //         (this.props.status === 'subscribed' &&
  //           data.currentUser.smsVerified))
  //     ) {
  //       this.props.history.push('/logout');
  //     }
  //   }
  // };

  closeModal = () => this.setState({ isModalOpen: false });
  openModal = () => this.setState({ isModalOpen: true });

  isVisible = page =>
    !this.isMobile
      ? this.state.currentPage === page || this.state.loaded[page]
      : true;
  isMobile = window.innerWidth < 768;

  render() {
    const landingCity = this.props.location.pathname;
    return (
      <Fragment>
        <ScrollLock>
          <Helmet>
            <title>Drive in San Francisco</title>
            <meta
              name="description"
              content="Join Autzu and start Drivesharing in San francisco! Drive Autzu EV on Uber & Lyft, starting from $7/hour. There are no upfront payments or term commitments. Sign up and driver in San Francisco today!"
            />
          </Helmet>
          <div className="landing__scroll">
            <Drivesharing
              status={this.props.status}
              signedIn={this.props.loggedIn}
              isMobile={this.isMobile}
              isVisible={this.isVisible(0)}
              currentPage={this.state.currentPage}
            />
            <WhyDrive isVisible={this.isVisible(1)} />
            <HowWorks
              isVisible={this.isVisible(2)}
              openModal={this.openModal}
            />
            <div className="landing__section">
              <SFVehicleTypes landing={true} />
            </div>
            {/* <Testimonial /> */}
            <LandingFaq
              isVisible={
                this.isMobile ? this.isVisible(6) : this.isVisible(4)
              }
            />
            {/* <Marketing /> */}
            <LandingSignup
              isVisible={
                this.isMobile ? this.isVisible(7) : this.isVisible(5)
              }
            />
            <SFFooter />
          </div>
        </ScrollLock>
      </Fragment>
    );
  }
}

export default withApollo(LandingPageSF);

const CHECK_VERIFICATION = gql`
  {
    currentUser {
      id
      smsVerified
      mobile
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageSF/index.js